import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAttendanceList,
  getReimbursementCategories,
  getReimbursementSpendLimit,
} from "_controllers/officer";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import { toastMessage } from "utils/toastMessage";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from "@mui/icons-material/GetApp";
import exportExcel from "utils/excelGenerate";
import authAxios from "setups/axios";

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "white",
  boxShadow: 24,
  p: 2,
  textAlign: "center",
};

const Main = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [categories, setCategories] = useState([]);
  const [spendLimit, setSpendLimit] = useState([]);

  const [open, setOpen] = useState(false);
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");

  const [zone, setZone] = useState("");
  const [region, setRegion] = useState("");
  const [area, setArea] = useState("");
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");

  const userType = [
    { value: "SO", name: "Sales Officer" },
    { value: "AO", name: "Area Manager" },
    { value: "RO", name: "Regional Manager" },
    { value: "ZO", name: "Zonal Manager" },
  ];

  useEffect(async () => {
    const attendance = await getAttendanceList({
      currentPage,
      search,
      zone,
      region,
      area,
    });
    setData(attendance?.data);
    setMessage(attendance?.message);
    setLoading(true);
    setTotalPages(attendance?.totalPage ?? 1);
  }, [message, currentPage, search]);

  useEffect(async () => {
    const categoryData = await getReimbursementCategories();
    setCategories(categoryData?.data);
    setLoading(true);
  }, [message]);

  useEffect(async () => {
    const categoryData = await getReimbursementSpendLimit();
    setSpendLimit(categoryData?.data);
    setLoading(true);
  }, [message]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const [formData, setFormData] = useState([]);

  const handleAmountChange = (categoryId, subCategoryId, amount) => {
    // Create a copy of the categories state
    const updatedCategories = [...categories];
    // Find the index of the category by its ID
    const categoryIndex = updatedCategories.findIndex(
      (cat) => cat._id === categoryId
    );
    if (categoryIndex !== -1) {
      // Find the index of the subcategory by its ID
      const subCategoryIndex = updatedCategories[
        categoryIndex
      ].subCategory.findIndex((subCat) => subCat._id === subCategoryId);
      if (subCategoryIndex !== -1) {
        // Update the amount of the subcategory
        updatedCategories[categoryIndex].subCategory[subCategoryIndex].amount =
          parseInt(amount) || 0;
        // Update the state with the new categories array
        setFormData(updatedCategories);
      }
    }
  };

  const handleSubmit = async () => {
    let updatedArr = formData.map((item) => {
      let updatedItem = {
        category: item._id,
        subCategory: item.subCategory.map((sub) => ({
          subCategory: sub._id,
          amount: parseInt(sub.amount),
        })),
      };
      return updatedItem;
    });

    let data = {
      role,
      spendLimit: updatedArr,
    };

    const response = await authAxios()({
      url: `/api/v1/admin/reimbursement/spend-limit`,
      method: "POST",
      data,
    });
    toastMessage(response?.data?.message, "success");
  };

  useEffect(() => {
    let updatedCategories = categories.map((category) => {
      let roSpendLimit = spendLimit.find((obj) => obj.role === role);
      if (roSpendLimit) {
        let updatedSubCategory = category.subCategory.map((subCategory) => {
          let matchedSubCategory = roSpendLimit.spendLimit
            .find((s) => s.category === category._id)
            ?.subCategory.find((sub) => sub.subCategory === subCategory._id);
          if (matchedSubCategory) {
            return { ...subCategory, amount: matchedSubCategory.amount };
          }
          return subCategory;
        });
        return { ...category, subCategory: updatedSubCategory };
      }
      return category;
    });
    setCategories(updatedCategories);
  }, [role]);

  return (
    <div
      style={{
        backgroundColor: "#F4F4F4",
        padding: "1rem",
        marginRight: "1rem",
        lineHeight: "2rem",
        borderRadius: "5px",
      }}
    >
      <div>
        <p
          style={{
            fontSize: "32px",
            fontWeight: "bolder",
            color: "#0E132F",
            fontWeight: "700",
            fontFamily: "Poppins",
            marginBottom: "1rem",
          }}
        >
          Edit Spend Limit
        </p>
      </div>
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />

      <div
        style={{
          backgroundColor: "#FCFCFC",
          borderRadius: "20px",
          padding: "1rem",
        }}
      >
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Select Position
        </p>
        <FormControl sx={{ mt: 1, mb: 2, minWidth: 400 }} size="small">
          <InputLabel id="zone-label">User</InputLabel>
          <Select
            labelId="zone-label"
            value={role}
            name="User"
            onChange={(event) => setRole(event.target.value)}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {userType?.map((item) => (
              <MenuItem key={item} value={item?.value}>
                {item?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <form>
          {categories?.map((category, idx) => (
            <div key={category._id}>
              <div
                style={{
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  padding: "5px 0",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#123064",
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    margin: "0 1rem",
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "#ffffff",
                  }}
                >
                  {idx + 1}
                </p>
                <p>{category.categoryName}</p>
              </div>
              <table style={{ marginLeft: "1rem" }}>
                <tbody>
                  {category?.subCategory.map((subCategory) => (
                    <tr key={subCategory?.subCategory?._id}>
                      <td
                        style={{
                          width: "150px",
                          fontSize: "16px",
                          fontWeight: "500",
                          fontFamily: "Poppins",
                          color: "#383838",
                        }}
                      >
                        {subCategory?.subCategory}
                      </td>
                      <td style={{}}>
                        <input
                          style={{
                            border: "1px solid #D8DAE5",
                            width: "131px",
                            height: "37px",
                            borderRadius: "8px",
                            padding: "0 8px",
                          }}
                          type="number"
                          value={subCategory?.amount || ""}
                          onChange={(e) =>
                            handleAmountChange(
                              category._id,
                              subCategory._id,
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </form>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1.5rem 0",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            fontFamily: "Poppins",
            fontWeight: "500",
            marginLeft: "0.5rem",
          }}
        >
          *limit are set to monthly by default
        </p>
        <div>
          <button
            type="submit"
            style={{
              width: "150px",
              height: "35px",
              padding: "7px 45px",
              backgroundColor: "#D1CECA",
              borderRadius: "6px",
              color: "#383838",
              fontSize: "16px",
              fontFamily: "Poppins",
              fontWeight: "500",
              marginRight: "1rem",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            style={{
              width: "150px",
              height: "35px",
              padding: "7px 45px",
              backgroundColor: "#3273F6",
              borderRadius: "6px",
              color: "#ffffff",
              fontSize: "16px",
              fontFamily: "Poppins",
              fontWeight: "500",
              cursor: "pointer",
            }}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

const SpendLimit = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default SpendLimit;
